import useModalStore from 'store/modal';

const useModal = () => {
  const { zstOpenModal, zstCloseModal, zstCloseCallback } = useModalStore();

  const openModal = (modalName, props = {}, closeCallback) => {
    zstOpenModal({
      modalName,
      props,
      closeCallback,
    });

    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    zstCloseModal();

    if (zstCloseCallback) {
      zstCloseCallback();
    }

    const drawerOverlay = document.querySelector('.drawer-overlay');
    if (drawerOverlay) return;

    document.body.style.overflow = 'unset';
  };

  return { openModal, closeModal };
};

export default useModal;
